<template>
	<div class="main">
		<header class="page-title">
			<h2>Translations</h2>
			<div class="ml-auto">
				<button @click="showCreateModal" class="btn btn-md btn-success" v-show="userRoles.includes('site_content.update') && !userRoles.includes('users.translator')">
					<i class="fas fa-plus"></i> New Translation
				</button>
			</div>
		</header>

		<translation-list-filter
				:data-endpoint="endPoint"
				:data-url-params="urlParams"
		></translation-list-filter>

		<translation-list :data-groups="groups"
						  :data-translation-list="translationList"
		></translation-list>

		<modal @close="closeCreateModal" v-show="isCreateModalVisible">
			<template slot="header">
				<h4 class="modal-title">New Translation</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group six-md">
						<label for="group">Group</label>
						<vue-select
								:options="groups"
								id="group"
								name="group"
								taggable
								v-model="translation.group">
						</vue-select>
					</div>
					<div class="form-group six-md">
						<label for="key">Key</label>
						<input id="key" type="text" v-model="translation.key">
						<p class="input-error" v-if="errors.errors.key">{{ errors.errors.key }}</p>
					</div>
				</div>
				<div class="card mt-1 mb-0">
					<header class="card-header language-list">
						<lang-selector></lang-selector>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="value">Text</label>
							<input id="value" type="text" v-model="translation[clickedLang].value">
						</div>
					</div>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeCreateModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click="saveTranslation" class="btn btn-md btn-success" href="#"><i class="fas fa-check"></i> Add New Translation</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from "../Modal/DefaultModal.vue";
	import {eventBus} from '../../app';
	import VueSelect from '../../../../node_modules/vue-select';
	import Errors from '../../Utils/Errors.js';

	export default {
		components: {
			modal,
			VueSelect
		},
		props: {
			dataTranslationList: {
				type: Array
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
			dataGroups: {
				type: Array
			}
		},
		data() {
			return {
				translationList: this.dataTranslationList,
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || [],
				groups: this.dataGroups,

				isCreateModalVisible: false,
				clickedLang: this.$defaultLanguage.locale,

				translation: {
					key: null,
					group: null,
				},

				userRoles: this.$currentUserRoles,
				errors: new Errors(),
			}
		},
		created() {
			let vm = this;

			for (let i = 0; i < vm.$availableLanguages.length; i++) {
				vm.translation[vm.$availableLanguages[i].locale] = {
					value: ''
				};
			}

			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

		},
		methods: {
			saveTranslation: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/translations', vm.translation)
					.then(response => {
						this.$toastr.success('New translation saved.');
						window.location.reload();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Save new translation failed.', 'Error');
					});
			},
			showCreateModal: function () {
				this.isCreateModalVisible = true;
			},
			closeCreateModal: function () {
				this.isCreateModalVisible = false;
			},
		}
	}
</script>

<style scoped>

</style>
